export default __webpack_public_path__ + "static/MichaelCoyle-0c1008f2ce765518f9108461bf394531.jpg";